// extracted by mini-css-extract-plugin
export default {"icon":"PopupIcon_icon__f6g2t"};